import {DialogContent, InputAdornment, Slider, styled, TextField, withStyles, Checkbox} from '@material-ui/core';
import CustSelect from './CustSelect';
import IconButton from "@material-ui/core/IconButton";
import {styleColors} from "src/main.style";
import {
  CustomCheckboxStyle,
  CustomDialogContentStyle,
  CustomSelectInvertedStyle,
  CustomSelectStyle,
  CustomTextFieldInvertedPStyle,
  CustomTextFieldInvertedStyle,
  CustomTextFieldStyle,
  StyledSliderStyle,
} from "./DialogComponens.style";
export {dialogStyles} from "./DialogComponens.style";

// slider should have min={0}, max={36}, step={1}
export const convertSliderValueToPercentage = (value:number):number => {
  if (value < 0) {return 0;}
  if (value > 36) {return 100;}
  if (value <= 7) {return value*5;}
  if (value >= 29) {return (60 + ((value-28)*5));}
  return value+32;
};

export const convertPercentageToSliderValue = (value:number):number => {
  if (value < 0) {return 0;}
  if (value > 100) {return 36;}
  if (value <= 40) {return value/5;}
  if (value >= 60) {return ((value-60)/5)+28;}
  return value-32;
};

export const CustomDialogContent =  withStyles(CustomDialogContentStyle)(DialogContent);

export const DialogTop = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  "& .MuiDialogTitle-root": {
    flex: 1,
    justifyContent: 'center',

    "& h2": {
      fontFamily: 'Metropolis',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '16px',
      textAlign: 'center',
      color: styleColors.greyDark2,
    },
  }
}));

export const Col = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const Row = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
}));

export const CustomCheckbox = withStyles(CustomCheckboxStyle)(Checkbox);

export const CustomTextField = withStyles(CustomTextFieldStyle)(TextField);

export const CustomTextFieldInverted = withStyles(CustomTextFieldInvertedStyle)(CustomTextField);

export const CustomTextFieldInvertedP = withStyles(CustomTextFieldInvertedPStyle)(CustomTextField);


export const CustomSelect = withStyles(CustomSelectStyle)(CustSelect);

export const CustomSelectInverted = withStyles(CustomSelectInvertedStyle)(CustomSelect);



export const StyledSlider = withStyles(StyledSliderStyle)(Slider);


export const StyledFormLabel = styled('legend')(({theme}) => ({
  fontFamily: 'Metropolis',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '8px',
  lineHeight: '8px',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: '1px',
  textTransform: 'uppercase',
  color: styleColors.warmGrey,
  marginBottom: theme.spacing(1),
}));

export const BoxedRow = styled(Row)(({theme}) => ({
  background: styleColors.greyLight2,
  borderRadius: '4px',
  position: 'relative',
  padding: theme.spacing(1),
}));

export const StyledButton = styled(IconButton)(({theme}) => ({
  background: styleColors.white,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.07)',
  borderRadius: '4px',
}));

export const StyledInputAdornment = styled(InputAdornment)(({theme}) => ({
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '13px',
  letterSpacing: '1px',
  textTransform: 'uppercase',
  transition: 'all 0.2s',
}));

export const StyledLabel = styled('label')(({theme}) => ({
  fontFamily: 'Metropolis',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '8px',
  lineHeight: '8px',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: '1px',
  textTransform: 'uppercase',
  color: styleColors.warmGrey,
}));

export const NoPrice = styled('div')(({theme}) => ({
  display: 'flex',
  padding: '12px 8px',
  fontSize: '11px',
  background: styleColors.white,
  fontStyle: 'normal',
  textAlign: 'center',
  alignItems: 'center',
  fontFamily: 'Metropolis',
  fontWeight: 400,
  lineHeight: '13px',
  letterSpacing: '1px',
  textTransform: 'uppercase',
  color: styleColors.greyMedium1,
  borderRadius: '4px',
  minHeight: '16px',
}));

export const CustomText = styled('div')(({theme}) => ({
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '8px',
  lineHeight: '8px',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: '1px',
  textTransform: 'uppercase',
  padding: '8px',
  color: styleColors.warmGrey,
  tranistion: 'all 0.3s',
  transitionDelay: '0.2s',
  height: 'calc(100% - 16px)',
  borderRadius: '4px',
}));

export const AmountLabel = styled('div')(({theme}) => ({
  fontFamily: 'Metropolis',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '13px',
  color: styleColors.greyDark2,
}));

export const PercentageLabel = styled('div')(({theme}) => ({
  fontFamily: 'Metropolis',
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '13px',
  lineHeight: '13px',
  color: styleColors.warmGrey,
}));



// WEBPACK FOOTER //
// ./src/components/economy/DialogComponens.ts